export default __webpack_public_path__ + "static/media/envelop_black.0590bf70.svg";